import { connect } from 'react-redux';

import { IRootState } from '../../../state-mgmt/rootState';
import { authState } from '../../../state-mgmt/auth';
import ProtectedRoute from './ProtectedRoute';
import { clientState } from 'modules/state-mgmt/client';
import { userState } from 'modules/state-mgmt/user';
import { generalState } from 'modules/state-mgmt/general';
import { GENERAL } from 'constants/general';

export const mapStateToProps = (state: IRootState) => ({
  authenticated: state.auth.authenticated,
  sessionChecked: state.auth.sessionChecked,
  currentUserPermissions: state.auth.session?.permissions,
  clientMap: state.client.clientMap,
  currentCompanyId: state.auth.currentCompanyId,
  companyUserId: state.auth.companyUserId,
  isFcaUser: state.auth.isFcaUser,
  featureMap: state.general.featuresMap,
  fetchingUserPermissions: state.general.loadingMap[GENERAL.LOADING_KEY.FETCH_USER_PERMISSIONS],
  fetchClientLoading: state.general.loadingMap[GENERAL.LOADING_KEY.FETCH_CLIENT],
  session: state.auth.session,
  failedTransactions: state.client.failedTransactions,
});

export const mapDispatchToProps = dispatch => ({
  recoverSession: () => {
    const authClientId = localStorage.getItem('auth-client-id');
    if (!authClientId || authClientId.length < 1) {
      dispatch(authState.actions.recoverSessionStart());
    }
  },
  fetchFeatureList: () => dispatch(generalState.actions.fetchFeatureListStart()),
  fetchClient: (id: string) => dispatch(clientState.actions.fetchClientStart(id)),
  getAccountData: () => dispatch(userState.actions.fetchProfileDataStart()),
  fetchAdminPermission: (id: string) => dispatch(clientState.actions.fetchAdminPermissionStart(id)),
  fetchFailedTransactions: (companyId: string) => dispatch(clientState.actions.fetchFailedTransactionsStart(companyId)),
});

export default connect(mapStateToProps, mapDispatchToProps)(ProtectedRoute);
